module.exports = __webpack_public_path__ + "static/img/history-bg.421db729.png";